export const DEFAULT_BORDER_COLOR = "#ebebf0";
export const FRESH_APPLICATION_BORDER_COLOR = "#2475A8";
export const CORECCTION_BORDER_COLOR = "#F5DA1D";
export const FRESH_APPLICATION_BACKGROUND = "#2475A8";
export const INPUT_FIELD_BACKGROUND = "#f1f4ff";
export const FRESH_APPLICATION = "#093AA0"
export const CORRECTION_APPLICATION = "#fbff30"